








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class CustomPDFViewer extends Vue {
  @Prop() readonly file: any

  get isAvailable() {
    return !!this.file
  }
}
